import React, { useState } from "react";
import {
  Button,
  Col,
  FloatingLabel,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { Stickies } from "react-bootstrap-icons";
import { GraphUser } from "../../../../graphql/types";
import { useChangeUserPasswordMutation } from "../../../graphql/userAdministration.hooks";
import { DeepPartial } from "../../../types";

interface IResetPasswordModalProps {
  isShow: boolean;
  handleCloseModal: () => void;
  selectedUser: DeepPartial<GraphUser>;
}

const ResetPasswordModal = ({
  isShow,
  handleCloseModal,
  selectedUser,
}: IResetPasswordModalProps) => {
  const [isPasswordReseted, setIsPasswordReseted] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const [changePassword, { loading }] = useChangeUserPasswordMutation({
    onCompleted: () => setIsPasswordReseted(true),
  });

  const handleResetPassword = () => {
    changePassword({
      variables: {
        userId: selectedUser?.id,
        password: newPassword,
      },
    });
  };

  return (
    <Modal
      show={isShow}
      onHide={handleCloseModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Reset User Password?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fs-6 text-center px-3 m-0 text-gray">
          This action will reset <b>{selectedUser?.email}</b> user&apos;s
          password. The new password will be displayed after the reset. Do you
          want to proceed?
        </p>
        {isPasswordReseted ? (
          <Row className="g-2 mt-4 align-items-center px-3">
            <Col xl={4}>
              <div>New Password:</div>
            </Col>

            <Col xl={8}>
              <div className="rounded bg-gray-light d-flex justify-content-between align-items-center ps-2">
                <div className="fw-bold">{newPassword}</div>
                <Button
                  variant="link"
                  className="w-auto"
                  onClick={() => navigator.clipboard.writeText(newPassword)}
                >
                  <Stickies className="text-primary fs-4" />
                </Button>
              </div>
            </Col>
          </Row>
        ) : (
          <FloatingLabel label="New Password" className="mt-4">
            <Form.Control
              type="text"
              placeholder="Enter new password"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
            />
          </FloatingLabel>
        )}
        <Row className="gx-3 mt-4">
          <Col xs={6}>
            <Button
              variant="outline-dark"
              onClick={handleCloseModal}
              className="w-100 fw-normal dark-hover"
            >
              Close
            </Button>
          </Col>
          <Col xs={6}>
            <Button
              variant="primary text-white fw-bold"
              onClick={handleResetPassword}
              className="w-100 fw-normal"
              disabled={loading || isPasswordReseted}
            >
              Reset Password {loading && <Spinner />}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ResetPasswordModal;
